import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { TbUser, TbFileInvoice, TbChecks, TbCircleOff } from 'react-icons/tb';
import { getToken, URL } from "../utils";






const InvoiceCard = () => {
  const [magasinId, setMagasinId] = useState(null);
  const [stats, setStats] = useState({
    nbre_ventes_total: 0,
    total_ventes: 0,
    ventes_gozem: 0,
    ca_gozem: 0,
  });

  const token = getToken();

  // useEffect(() => {
  //   const getUserInfo = async () => {
  //     try {
  //       const response = await axios.get(URL + `authentification/user-info`, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       setMagasinId(response.data.magasin_id);
  //     } catch (error) {
  //       console.error("Erreur lors de la récupération des informations utilisateur :", error);
  //     }
  //   };

  //   getUserInfo();
  // }, [token]);

  useEffect(() => {
    const fetchStats = async () => {
      // if (!magasinId) return;

      try {
        const response = await axios.get(
          URL + `Declarations/stats-factures`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setStats(response.data); 
      } catch (error) {
        console.error("Erreur lors de la récupération des statistiques :", error);
      }
    };

    fetchStats();
  }, [magasinId, token]);

  const data = [
    {
      title: stats.nbre_ventes_total,
      subtitle: 'Nombre total de ventes',
      icon: <TbUser size={26} />,
    },
    {
      title: `${stats.total_ventes.toLocaleString()} FCFA`,
      subtitle: 'Somme totale',
      icon: <TbFileInvoice size={26} />,
    },
    {
      title: `${stats.ventes_gozem} ventes`,
      subtitle: 'Ventes via Gozem',
      ca: <span>{stats.ca_gozem.toLocaleString()} FCFA</span>,
      icon: (
      <img
        src="/gozem.jpg" 
        alt="Logo"
        style={{ width: 26, height: 26, objectFit: 'contain' }}
      />
    ),
    },
  ];



  return (
    <Card>
      <CardContent>
        <Grid container spacing={6}>
          {data.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <div className='flex justify-between items-center h-32'>
                <div className='flex flex-col items-start gap-2'>
                  <Typography variant='h4'>{item.title}</Typography>
                  {item.ca && <>{item.ca}</>}
                  <Typography>{item.subtitle}</Typography>
                </div>
                <Avatar variant='rounded' className='is-[42px] bs-[42px]'>
                  {item.icon}
                </Avatar>
              </div>
              <Divider className='mbs-6' />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default InvoiceCard;